import * as z from 'zod/mini'
import { refineWithKey } from '../errors/validation-keys'
import { isoDateTime } from './common'

/** The longest announcement title. Matches the `title` column of `EntityPostEntity`. */
export const MAX_ANNOUNCEMENT_TITLE = 120

/**
 * Field rules for a premise's announcement (`EntityPostEntity`), shared by the editor's form, the
 * HTTP body and the domain operation.
 *
 * - `title` is plain text and required: it is what both looks always show.
 * - `content` is the optional rich text behind "Zobraziť viac". Sanitised by the API before storing.
 * - `showFrom` / `hideAfter` bound when it is shown; `null` is unbounded. Instants in UTC.
 */
export const entityPostFields = {
  title: z.string().check(
    z.trim(),
    refineWithKey('validation.required', (value: string) => value.length > 0),
    z.maxLength(MAX_ANNOUNCEMENT_TITLE),
  ),
  content: z.string().check(z.maxLength(50000)),
  showFrom: z.nullable(isoDateTime),
  hideAfter: z.nullable(isoDateTime),
}
